import {
  Card,
  CardContent,
  CardHeader,
  Divider,
  FormControl,
  FormHelperText,
  Stack,
  ButtonGroup
} from "@mui/material";
import Grid from "@mui/material/Grid2";
import MaterialTypography from "../components/MaterialTypography";
import ConfirmationDialog from "../components/Dialog/ConfirmationDialog";
import MaterialBox from "../components/MaterialBox";
import MaterialInput from "../components/MaterialInput";
import BASEURL from "../pages/Utils/Baseurl";
import { useEffect, useState } from "react";
import MaterialButton from "../components/MaterialButton";
import { useUserDetails } from "../context/auth";
import DashboardLayout from "../layoutcontainers/DashboardLayout";
import SelectPlaceholder from "./Selecttool";
import MaterialSelect from "../components/MasterSelect";
import axios from "axios";
import Swal from "sweetalert2";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import { useNavigate } from "react-router-dom";

const Screening = () => {
  const [screening, setscreening] = useState({
    jobid: "",
    candidatename: "",
    screeningStatus:'',
    source: "",
    mobile: "",
    emailid: "",
    totalexperience: "",
    relevantexperience: "",
    currentctc: "",
    expectedctc: "",
    leadtime: "",
    yearpassing: "",
    currentemployer: "",
    location: "",
    comments: "",
    interviewavailability: "",
    interviewer: "",

    jobidStatus: "unchecked",
    candidatenameStatus: "unchecked",
    sourceStatus: "unchecked",
    mobileStatus: "unchecked",
    emailidStatus: "unchecked",
    totalexperienceStatus: "unchecked",
    relevantexperienceStatus: "unchecked",
    currentctcStatus: "unchecked",
    expectedctcStatus: "unchecked",
    leadtimeStatus: "unchecked",
    yearpassingStatus: "unchecked",
    currentemployerStatus: "unchecked",
    locationStatus: "unchecked",
    commentsStatus: "unchecked",
    interviewavailabilityStatus: "unchecked",
    interviewerStatus: "unchecked",
    screeningStatusStatus: "unchecked",
  });
  const navigate = useNavigate();
 

   const [pageState, setPageState] = useState({
      loading: false,
      error: false,
      message: "",
      state: "init",
    });

    const [togglePage, setTogglePage] = useState({
        view: false,
        edit: false,
      });
  
  const {AccessData} = useUserDetails();

  const [display,setdisplay] = useState(true)

 let ScreenStatus = [
  {value:'Accepted',label:'Selected'},
  {value:'Rejected',label:'Rejected'},
 ]

const [confirmationDialog, setConfirmationDialog] = useState({
    open: false,
    title: "",
    message: "",
    showCancel: true,
    customSection: null,
    onConfirm: () => {},
    onCancel: () => {},
  });

  const [id, setId] = useState(null);

  useEffect(() => {
    const queryParams = new URLSearchParams(window.location.search);
    const id = queryParams.get("id");
    setId(id);
    if (id) {
      getInitData(id);
    } else {
      // setPageState((prevState) => ({
      //   ...prevState,
      //   loading: false,
      //   state: "default",
      // }));
    }
  }, []);
  const [editBtnEnabled, setEditBtnEnabled] = useState(false);

  const formatIndianNumber1 = (num) => {
    if (!num) return ""; // Handle empty values gracefully
  
    let x = num.toString().replace(/,/g, ""); // Ensure it's a string and remove existing commas
    let lastThree = x.slice(-3);
    let otherNumbers = x.slice(0, -3);
  
    if (otherNumbers !== "") {
      lastThree = "," + lastThree;
    }
    
    return otherNumbers.replace(/\B(?=(\d{2})+(?!\d))/g, ",") + lastThree;
  };
  const getInitData = async (id) => {
    const query = `query GetSourcingScreeningById($id: ID!) {
  sourcingScreening(id: $id) {
    id
    jobid
    candidateName
    screeningStatus
    source
    emailid
    mobileNumber
    totalExperience
    relevantExperience
    currentCtc
    expectedCtc
    leadTime
    yearOfPassing
    currentEmployer
    location
    comments
    interviewAvailability
    interviewer
    cvFile
  }
} `;
    try {
      const response = await axios.post(
        BASEURL,
        {
          query: query,
          variables: { id },
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      console.log("responsewwww:", response.data);
      let result = response.data.data.sourcingScreening
      console.log('SDFGGH:',result.screeningStatus);
       let valuedata = result.screeningStatus =='Accepted' ? {value : 'Accepted',label:'Selected'} : result.screeningStatus =='Rejected' ? {value : 'Rejected',label:'Rejected'} : ''


       const isEditable = [
        result.totalExperience,
        result.relevantExperience,
        result.currentCtc,
        result.screeningStatus,
        result.expectedCtc,
        result.leadTime,
        result.yearOfPassing,
        result.currentEmployer,
        result.location,
        
      ].every((val) => val !== "" && val !== null && val !== undefined);
      setTogglePage({
        ...togglePage,
        view: isEditable,
      });

       setscreening({
        ...screening,
        jobid: {value:result.jobid,label:result.jobid},
        candidatename: result.candidateName,
        screeningStatus:{value:valuedata?.value,label:valuedata?.label},
        source : {value:result.source,label:result.source},
        mobile: result.mobileNumber,
        emailid: result.emailid,
        totalexperience: result.totalExperience,
        relevantexperience : result.relevantExperience,
        currentctc : formatIndianNumber1(result.currentCtc),
        expectedctc : formatIndianNumber1(result.expectedCtc),
        leadtime : result.leadTime,
        yearpassing : result.yearOfPassing,
        currentemployer : result.currentEmployer,
        location : result.location,
        comments : result.comments,
        interviewavailability: result.interviewAvailability
    ? new Date(result.interviewAvailability).toISOString().slice(0, 16)
    : "",
        interviewer : result.interviewer,
        totalexperienceStatus:  result.totalExperience ? "success" : "unchecked",
        relevantexperienceStatus: result.relevantExperience ? "success" : "unchecked",
        currentctcStatus:  result.currentCtc ? "success" : "unchecked",
        expectedctcStatus: result.expectedCtc ? "success" : "unchecked",
        leadtimeStatus: result.leadTime ? "success" : "unchecked",
        yearpassingStatus: result.yearOfPassing ? "success" : "unchecked",
        currentemployerStatus: result.currentEmployer ? "success" : "unchecked",
        locationStatus: result.location ? "success" : "unchecked" ,
        commentsStatus: result.comments ? "success" : "unchecked" ,
        interviewavailabilityStatus:  result.interviewAvailability ? "success" : "unchecked" ,
        interviewerStatus: result.interviewer ? "success" : "unchecked" ,
        screeningStatusStatus: result.screeningStatus  ? "success" : "unchecked" ,
        
       })
    } catch (error) {
      console.error("ResponseError:", error);
      setConfirmationDialog({
        open: true,
        title: "Error massage",
        message:
          "Sorry for your inconvience, there is some issue in our network. Please try again later.",
        showCancel: true,
        showConfirm: false,

        onCancel: () => {
          setConfirmationDialog({
            ...confirmationDialog,
            open: false,
          });
        },
      });
    }
  };


  const jobidlist = [
    { value: "DFG4566", label: "DFG4566" },
    { value: "DFGBNN", label: "DFGBNN" },
  ];

  const Source = [
    { value: "LinkedIn", label: "LinkedIn" },
    { value: "Indeed", label: "Indeed" },
    { value: "AngelList", label: "AngelList" },
    { value: "GitHub", label: "GitHub" },
    { value: "Upwork", label: "Upwork" },
    { value: "Stack Overflow Careers", label: "Stack Overflow Careers" },
    { value: "Xing", label: "Xing" },
    { value: "Recruitee", label: "Recruitee" },
    { value: "Hiretual", label: "Hiretual" },
    { value: "Monster", label: "Monster" },
    { value: "SimplyHired", label: "SimplyHired" },
    { value: "Toptal", label: "Toptal" },
    { value: "Jobvite", label: "Jobvite" },
    { value: "Workable", label: "Workable" },
    { value: "Recruitment Agency", label: "Recruitment Agency" },
    { value: "Employee referral", label: "Employee referral" },
  ]

  const formatIndianNumber = (num) => {
    let x = num.replace(/,/g, ""); // Remove existing commas
    let lastThree = x.slice(-3);
    let otherNumbers = x.slice(0, -3);
    if (otherNumbers !== "") {
      lastThree = "," + lastThree;
    }
    return otherNumbers.replace(/\B(?=(\d{2})+(?!\d))/g, ",") + lastThree;
  };
  const handlepostiondetails222 = (event) => {
    let value = event.target.value.replace(/,/g, ""); // Remove existing commas

    if (value === "") {
      // If input is cleared, reset the status and value
      setscreening((prevState) => ({
        ...prevState,
        currentctc: "",
        currentctcStatus: "unchecked",
        
      }));
    } else if (/^\d{0,7}$/.test(value)) {
      // Allow only numbers up to 7 digits
      let formattedValue = formatIndianNumber(value);

      setscreening((prevState) => ({
        ...prevState,
        currentctc: formattedValue,
        currentctcStatus: value.length >= 5 ? "success" : "error",
      }));
    }
  };
  const handlepostiondetails33 = (event) => {
    let value = event.target.value.replace(/,/g, ""); // Remove existing commas

    if (value === "") {
      // If input is cleared, reset the status and value
      setscreening((prevState) => ({
        ...prevState,
        expectedctc: "",
        expectedctcStatus: "unchecked",
        
      }));
    } else if (/^\d{0,7}$/.test(value)) {
      // Allow only numbers up to 7 digits
      let formattedValue = formatIndianNumber(value);

      setscreening((prevState) => ({
        ...prevState,
        expectedctc: formattedValue,
        expectedctcStatus: value.length >= 5 ? "success" : "error",
      }));
    }
  };

  const handleScreenChange = (event, selectEvent) => {
    console.log("selectEvent:", selectEvent, event?.label);
    let sourceState = { ...screening };

    if (event?.target === undefined && selectEvent) {
      if (selectEvent.name === "jobid") {
        const lengthRegex = new RegExp("^[A-Za-z0-9]");
        if (lengthRegex.test(event?.label) === true) {
          sourceState[selectEvent.name + "Status"] =
            event?.label === undefined ? "unchecked" : "success";
        } else {
          sourceState[selectEvent.name + "Status"] =
            selectEvent.value === "" ? "unchecked" : "error";
        }
      }
      if (selectEvent.name === "screeningStatus") {
        const lengthRegex = new RegExp("^[A-Za-z0-9]");
        if (lengthRegex.test(event?.label) === true) {
          sourceState[selectEvent.name + "Status"] =
            event?.label === undefined ? "unchecked" : "success";
        } else {
          sourceState[selectEvent.name + "Status"] =
            selectEvent.value === "" ? "unchecked" : "error";
        }
      }
      if (selectEvent.name === "source") {
        const lengthRegex = new RegExp("^[A-Za-z0-9]");
        if (lengthRegex.test(event?.label) === true) {
          sourceState[selectEvent.name + "Status"] =
            event?.label === undefined ? "unchecked" : "success";
        } else {
          sourceState[selectEvent.name + "Status"] =
            selectEvent.value === "" ? "unchecked" : "error";
        }
      }
      // if (selectEvent.name === "interviewer") {
      //   const lengthRegex = new RegExp("^[A-Za-z0-9]");
      //   if (lengthRegex.test(event?.label) === true) {
      //     sourceState[selectEvent.name + "Status"] =
      //       event?.label === undefined ? "unchecked" : "success";
      //   } else {
      //     sourceState[selectEvent.name + "Status"] =
      //       selectEvent.value === "" ? "unchecked" : "error";
      //   }
      // }
      sourceState[selectEvent.name] = event;
    } else {
      const changeAllowed = true;
      switch (event.target.name) {
        case "candidatename":
          {
            const alphaNumberLengthRegex = new RegExp("^([a-zA-Z ]{1,40})$");
            // const alphaNumberLengthRegex = new RegExp('^([A-Za-z]{1,15})$');

            if (alphaNumberLengthRegex.test(event.target.value?.trim())) {
              sourceState[event.target.name + "Status"] = "success";
            } else {
              sourceState[event.target.name + "Status"] =
                event.target.value === "" ? "unchecked" : "error";
            }
          }
          break;
        case "interviewer":
          {
            const alphaNumberLengthRegex = new RegExp("^([a-zA-Z ]{1,40})$");
            // const alphaNumberLengthRegex = new RegExp('^([A-Za-z]{1,15})$');

            if (alphaNumberLengthRegex.test(event.target.value?.trim())) {
              sourceState[event.target.name + "Status"] = "success";
            } else {
              sourceState[event.target.name + "Status"] =
                event.target.value === "" ? "unchecked" : "error";
            }
          }
          break;
        case "mobile":
          {
            const alphaNumberLengthRegex = new RegExp("^[0-9]{10}$");
            // const alphaNumberLengthRegex = new RegExp('^([A-Za-z]{1,15})$');

            if (alphaNumberLengthRegex.test(event.target.value?.trim())) {
              sourceState[event.target.name + "Status"] = "success";
            } else {
              sourceState[event.target.name + "Status"] =
                event.target.value === "" ? "unchecked" : "error";
            }
          }
          break;
        case "emailid":
          {
            const emailRegex = new RegExp(/^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/g);
            // const alphaNumberLengthRegex = new RegExp('^([A-Za-z]{1,15})$');

            if (emailRegex.test(event.target.value?.trim())) {
              sourceState[event.target.name + "Status"] = "success";
            } else {
              sourceState[event.target.name + "Status"] =
                event.target.value === "" ? "unchecked" : "error";
            }
          }
          break;
        case "totalexperience":
          {
            const alphaNumberLengthRegex = /^\d{0,2}(\.\d{0,2})?$/;
            if (alphaNumberLengthRegex.test(event.target.value?.trim())) {
              sourceState[event.target.name + "Status"] = "success";
            } else {
              sourceState[event.target.name + "Status"] =
                event.target.value === "" ? "unchecked" : "error";
            }
          }
          break;
        case "relevantexperience":
          {
            const alphaNumberLengthRegex = /^\d{0,2}(\.\d{0,2})?$/;

            if (alphaNumberLengthRegex.test(event.target.value?.trim())) {
              sourceState[event.target.name + "Status"] = "success";
            } else {
              sourceState[event.target.name + "Status"] =
                event.target.value === "" ? "unchecked" : "error";
            }
          }
          break;
        case "currentctc":
          {
            
            const numberRegex = new RegExp(/^\d+$/);

            if (numberRegex.test(event.target.value?.trim())) {
              sourceState[event.target.name + "Status"] = "success";
            } else {
              sourceState[event.target.name + "Status"] =
                event.target.value === "" ? "unchecked" : "error";
            }
          }
          break;
        case "expectedctc":
          {
            const numberRegex = new RegExp(/^\d+$/);

            if (numberRegex.test(event.target.value?.trim())) {
              sourceState[event.target.name + "Status"] = "success";
            } else {
              sourceState[event.target.name + "Status"] =
                event.target.value === "" ? "unchecked" : "error";
            }
          }
          break;
        case "leadtime":
          {
            const numberRegex = /^[a-zA-Z0-9]+$/;

            if (numberRegex.test(event.target.value?.trim())) {
              sourceState[event.target.name + "Status"] = "success";
            } else {
              sourceState[event.target.name + "Status"] =
                event.target.value === "" ? "unchecked" : "error";
            }
          }
          break;
          case "yearpassing":
            {
              const alphaNumberLengthRegex = /^\d{0,4}(\.\d{0,4})?$/;
          
              if (event.target.value.trim() === "") {
                sourceState[event.target.name + "Status"] = "unchecked"; // Hide error
              } else if (alphaNumberLengthRegex.test(event.target.value.trim())) {
                sourceState[event.target.name + "Status"] = "success";
              } else {
                sourceState[event.target.name + "Status"] = "error";
              }
            }
            break;
          
        case "currentemployer":
          {
            const alphaNumberLengthRegex = new RegExp("^([a-zA-Z ]{1,75})$");
            // const alphaNumberLengthRegex = new RegExp('^([A-Za-z]{1,15})$');

            if (alphaNumberLengthRegex.test(event.target.value?.trim())) {
              sourceState[event.target.name + "Status"] = "success";
            } else {
              sourceState[event.target.name + "Status"] =
                event.target.value === "" ? "unchecked" : "error";
            }
          }
          break;
        case "location":
          {
            // const alphaNumberLengthRegex = new RegExp("^([a-zA-Z ]{1,25})$");
            // const alphaNumberLengthRegex = /^([a-zA-Z0-9 ]{1,250})$/;
            // const alphaNumberLengthRegex = new RegExp(
            //   "^[a-zA-Z0-9 !@#$%^&*()_+{}|:\"<>?`\\[\\]\\\\;,./'-=~ ]{1,1000}$"
            // );
            const alphaNumberLengthRegex = new RegExp("^.{1,25}$", "s");

            if (alphaNumberLengthRegex.test(event.target.value?.trim())) {
              sourceState[event.target.name + "Status"] = "success";
            } else {
              sourceState[event.target.name + "Status"] =
                event.target.value === "" ? "unchecked" : "error";
            }
          }
          break;
        case "comments":
          {
            // const alphaNumberLengthRegex = new RegExp(
            //   "^[a-zA-Z0-9 !@#$%^&*()_+{}|:\"<>?`\\[\\]\\\\;,./'-=~ ]{1,100}$"
            // );
            const alphaNumberLengthRegex = new RegExp("^.{1,100}$", "s");
            // const alphaNumberLengthRegex = new RegExp('^([A-Za-z]{1,15})$');

            if (alphaNumberLengthRegex.test(event.target.value?.trim())) {
              sourceState[event.target.name + "Status"] = "success";
            } else {
              sourceState[event.target.name + "Status"] =
                event.target.value === "" ? "unchecked" : "error";
            }
          }
          break;

        case "interviewavailability":
          {
            if (event.target.value?.trim()) {
              sourceState[event.target.name + "Status"] = "success";
              const dateOnly = event.target.value.split("T")[0];
            } else {
              sourceState[event.target.name + "Status"] =
                event.target.value === "" ? "unchecked" : "error";
            }
          }
          break;
      }
      if (changeAllowed) {
        sourceState[event.target.name] = event.target.value;
      }
    }
    setscreening(sourceState);
  };

  const checkAllFields = () => {
    let allowSubmit = false;
    if (
     
    
  
      screening.totalexperienceStatus === "success"&&
      screening.relevantexperienceStatus === "success"&&
      screening.currentctcStatus === "success"&&
      screening.expectedctcStatus === "success"&&
      screening.leadtimeStatus === "success"&&
      screening.yearpassingStatus === "success"&&
      screening.currentemployerStatus === "success"&&
      screening.screeningStatusStatus === "success"&&
      screening.locationStatus === "success"
    ) {
      allowSubmit = true;
    } else {
      allowSubmit = false;
    }
    return allowSubmit;
  };


  const handleAddSource = () => {
    setConfirmationDialog({
      open: true,
      title: "Confirmation",
      message: "Are you sure you want to submit your details?",
      showCancel: true,
      showConfirm: true,
      onConfirm: () => {
        handlesubmit();
      },
      onCancel: () => {
        setConfirmationDialog({
          ...confirmationDialog,
          open: false,
        });
      },
    });
  };

  const handlesubmit = async()=>{
   const query =`mutation UpdateSourcingScreening($id: ID!, $input: SourcingScreeningInput!) {
  updateSourcingScreening(id: $id, input: $input) {
    sourcingScreening {
      id
      jobid
      candidateName
      screeningStatus
      source
      emailid
      mobileNumber
      totalExperience
      relevantExperience
      currentCtc
      expectedCtc
      leadTime
      yearOfPassing
      currentEmployer
      location
      comments
      interviewAvailability
      interviewer
      cvFile
    }
  }
}`

    let screenvalue = ''

    if(screening.screeningStatus == ''){

    }

  const alldata = {
    jobid: screening.jobid?.value,
    candidateName: screening.candidatename,
    screeningStatus: screening.screeningStatus?.value,
    source: screening.source?.value,
    mobileNumber: screening.mobile,
    emailid: screening.emailid,
    totalExperience:screening?.totalexperience,
    relevantExperience:screening?.relevantexperience,
    currentCtc:screening?.currentctc.replace(/,/g, ""),
    expectedCtc:screening?.expectedctc.replace(/,/g, ""),
    leadTime:screening?.leadtime,
    yearOfPassing:screening?.yearpassing,
    currentEmployer:screening?.currentemployer,
    location:screening?.location,
    comments:screening?.comments,
    interviewAvailability:screening?.interviewavailability,
    interviewer:screening?.interviewer,
  }



    

     try {
     
      const response = await axios.post(BASEURL, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        query,
        variables: {
          id:id,
          input: alldata,
        },
      });
        
        setConfirmationDialog({
          ...confirmationDialog,
          open: false,
        });

         const finaldata =
                response.data.data.updateSourcingScreening.sourcingScreening;

                console.log('finaldata:',finaldata);
                
        
              if (finaldata !== "") {
                Swal.fire({
                  position: "center",
                  icon: "success",
                  title: "Screening Submitted Successfully!",
                  showConfirmButton: false,
                  timer: 2500,
                });
                navigate("/sourcing");
              }
  
      } catch (error) {
        console.error("responseError:", error);
        setConfirmationDialog({
          open: true,
          title: "Error message",
          message:
            "Sorry for your inconvenience, there is some issue in our network. Please try again later.",
          showCancel: true,
          showConfirm: false,
          onCancel: () => {
            setConfirmationDialog({
              ...confirmationDialog,
              open: false,
            });
          },
        });
      }
  }

  const handleEdit = () => {
    setConfirmationDialog({
      open: true,
      title: "Confirmation",
      message: "Are you sure you want to Update your details?",
      showCancel: true,
      showConfirm: true,
      onConfirm: () => {
        UpdateScreening();
      },
      onCancel: () => {
        setConfirmationDialog({
          ...confirmationDialog,
          open: false,
        });
      },
    });
  };

  const UpdateScreening = async () => {
    const query = `
      mutation UpdateSourcingScreening($id: ID!, $input: SourcingScreeningInput!) {
        updateSourcingScreening(id: $id, input: $input) {
          sourcingScreening {
            id
            jobid
            candidateName
            source
            emailid
            mobileNumber
            totalExperience
            relevantExperience
            currentCtc
            expectedCtc
            leadTime
            yearOfPassing
            currentEmployer
            location
            comments
            interviewAvailability
            interviewer
          }
        }
      }
    `;
  
    const alldata = {
      jobid: screening?.jobid.value,
      candidateName: screening?.candidatename,
      screeningStatus: screening?.screeningStatus?.value,  
      source: screening?.source?.value,
      mobileNumber: screening?.mobile,
      emailid: screening?.emailid,
      totalExperience: screening?.totalexperience,
      relevantExperience: screening?.relevantexperience,
      currentCtc: screening?.currentctc.replace(/,/g, ""),
      expectedCtc: screening?.expectedctc.replace(/,/g, ""),
      leadTime: screening?.leadtime,
      yearOfPassing: screening?.yearpassing,
      currentEmployer: screening?.currentemployer,
      location: screening?.location,
      comments: screening?.comments,
      interviewAvailability: screening?.interviewavailability,
      interviewer: screening?.interviewer,
    };
  
    console.log("alldata:",alldata);
    

    try {
      const response = await axios.post(BASEURL, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        query,
        variables: {
          id: id,
          input: alldata,
        },
      });
  
    

        setConfirmationDialog({
              ...confirmationDialog,
              open: false,
            });
      
            let finaldata = response.data.data?.updateSourcingScreening?.sourcingScreening
            ;
      
            if (finaldata !== "") {
              Swal.fire({
                position: "center",
                icon: "success",
                title: "Screening Updated Successfully!",
                showConfirmButton: false,
                timer: 2500,
              });
              navigate("/sourcing");
            }
    } catch (error) {
      console.error("Network or unexpected error:", error);
      setConfirmationDialog({
        open: true,
        title: "Error message",
        message:
          "Sorry for the inconvenience, there is an issue with our network. Please try again later.",
        showCancel: true,
        showConfirm: false,
        onCancel: () => {
          setConfirmationDialog({
            ...confirmationDialog,
            open: false,
          });
        },
      });
    }
  };
  

  const toggleEdit = () => {
    setTogglePage({
      view: false,
      edit: true,
    });
  };

  const handlecancel = ()=>{
    navigate('/sourcing')
  }

  return (
    <DashboardLayout>
       {confirmationDialog.open && (
                      <ConfirmationDialog
                        open={confirmationDialog.open}
                        title={confirmationDialog.title}
                        message={confirmationDialog.message}
                        showCancel={confirmationDialog.showCancel}
                        showConfirm={confirmationDialog.showConfirm}
                        customSection={confirmationDialog.customSection}
                        onConfirm={confirmationDialog.onConfirm}
                        onCancel={confirmationDialog.onCancel}
                      />
                    )}
      <Card>
      <CardHeader
          title={
            <>
              {togglePage.view === true || togglePage.edit === true ? (
                <Stack
                  direction="row"
                  justifyContent="space-between"
                  alignItems="center"
                  spacing={2}
                >
                  <Stack direction="column" spacing={0}>
                    <MaterialTypography variant="h5" fontWeight="medium">
                      Edit Screening
                    </MaterialTypography>
                  </Stack>
                  {AccessData &&
                    Array.isArray(AccessData) &&
                    AccessData.some(
                      (item) =>
                        item.component === "EditSourcing" && item.can_access
                    ) &&
                    pageState.state !== "submitting" && (
                      <ButtonGroup
                        variant="outlined"
                        aria-label="Loading button group"
                      >
                        <MaterialButton
                          variant="gradient"
                          color="dark"
                          onClick={toggleEdit}
                          startIcon={<EditIcon />}
                        >
                          Edit
                        </MaterialButton>
                        {/* <MaterialButton
                          variant="gradient"
                          color="dark"
                          // onClick={AddDelete}
                          startIcon={<DeleteIcon />}
                        >
                          Delete
                        </MaterialButton> */}
                      </ButtonGroup>
                    )}
                </Stack>
              ) : (
                <Stack
                  direction="row"
                  justifyContent="space-between"
                  alignItems="center"
                  spacing={2}
                >
                  <Stack direction="column" spacing={0}>
                    <MaterialTypography variant="h5" fontWeight="medium">
                      Add Source
                    </MaterialTypography>
                  </Stack>
                </Stack>
              )}
            </>
          }
        />
        <CardContent>
          <Grid container spacing={2}>
            <Grid size={{ xs: 5, sm: 4 }}>
              <MaterialBox lineHeight={0} display="inline-block">
                <MaterialTypography
                  component="label"
                  variant="caption"
                  fontWeight="bold"
                >
                  Job ID <span style={{ color: "red" }}>*</span>
                </MaterialTypography>
              </MaterialBox>
              <MaterialSelect
                name="jobid"
                value={screening.jobid}
                customStyles={{ optionPadding: 20 }}
                onChange={handleScreenChange} //selectedValue, event
                options={jobidlist.map((value) => {
                  return {
                    value: value.value,
                    label: value.label,
                  };
                })}
                error={screening.jobidStatus === "error" ? true : false}
                success={screening.jobidStatus === "success" ? true : false}
                  isDisabled={display}
                //   isClearable
              />
              {screening.jobidStatus === "error" && (
                <FormControl error>
                  <FormHelperText>Job ID is Mandatory</FormHelperText>
                </FormControl>
              )}
            </Grid>
            <Grid size={{ xs: 5, sm: 4 }}>
              <MaterialBox lineHeight={0} display="inline-block">
                <MaterialTypography
                  component="label"
                  variant="caption"
                  fontWeight="bold"
                >
                  Candidate Name <span style={{ color: "red" }}>*</span>
                </MaterialTypography>
              </MaterialBox>
              <MaterialInput
                name="candidatename"
                value={screening.candidatename}
                customStyles={{ optionPadding: 20 }}
                onChange={handleScreenChange}
                error={screening.candidatenameStatus === "error" ? true : false}
                success={
                  screening.candidatenameStatus === "success" ? true : false
                }
                disabled={display}
                //   isClearable
              />
              {screening.candidatenameStatus === "error" && (
                <FormControl error>
                  <FormHelperText>
                    Candidate Name should be a maximum of 40 characters long and
                    can contain only alphabets.
                  </FormHelperText>
                </FormControl>
              )}
            </Grid>
            <Grid size={{ xs: 5, sm: 4 }}>
              <MaterialBox lineHeight={0} display="inline-block">
                <MaterialTypography
                  component="label"
                  variant="caption"
                  fontWeight="bold"
                >
                  Source <span style={{ color: "red" }}>*</span>
                </MaterialTypography>
              </MaterialBox>
              <MaterialSelect
                name="source"
                value={screening.source}
                customStyles={{ optionPadding: 20 }}
                onChange={handleScreenChange} //selectedValue, event
                options={Source.map((value) => {
                  return {
                    value: value.value,
                    label: value.label,
                  };
                })}
                error={screening.sourceStatus === "error" ? true : false}
                success={screening.sourceStatus === "success" ? true : false}
                isDisabled={display}
                //   isClearable
              />
              {screening.sourceStatus === "error" && (
                <FormControl error>
                  <FormHelperText>Source is Mandatory</FormHelperText>
                </FormControl>
              )}
            </Grid>
            <Grid size={{ xs: 5, sm: 4 }}>
              <MaterialBox lineHeight={0} display="inline-block">
                <MaterialTypography
                  component="label"
                  variant="caption"
                  fontWeight="bold"
                >
                  Mobile No <span style={{ color: "red" }}>*</span>
                </MaterialTypography>
              </MaterialBox>
              <MaterialInput
                name="mobile"
                value={screening.mobile}
                customStyles={{ optionPadding: 20 }}
                onChange={handleScreenChange} //selectedValue, event
                error={screening.mobileStatus === "error" ? true : false}
                success={screening.mobileStatus === "success" ? true : false}
                disabled={display}
                //   isClearable
              />
              {screening.mobileStatus === "error" && (
                <FormControl error>
                  <FormHelperText>
                    Mobile number should be 10 characters long and can contain
                    only numbers.
                  </FormHelperText>
                </FormControl>
              )}
            </Grid>
            <Grid size={{ xs: 5, sm: 4 }}>
              <MaterialBox lineHeight={0} display="inline-block">
                <MaterialTypography
                  component="label"
                  variant="caption"
                  fontWeight="bold"
                >
                  Email ID <span style={{ color: "red" }}>*</span>
                </MaterialTypography>
              </MaterialBox>
              <MaterialInput
                name="emailid"
                value={screening.emailid}
                customStyles={{ optionPadding: 20 }}
                onChange={handleScreenChange}
                error={screening.emailidStatus === "error" ? true : false}
                success={screening.emailidStatus === "success" ? true : false}
                disabled={display}
                //   isClearable
              />
              {screening.emailidStatus === "error" && (
                <FormControl error>
                  <FormHelperText>
                    Please enter a valid email address
                  </FormHelperText>
                </FormControl>
              )}
            </Grid>
            <Grid size={{ xs: 5, sm: 4 }}>
              <MaterialBox lineHeight={0} display="inline-block">
                <MaterialTypography
                  component="label"
                  variant="caption"
                  fontWeight="bold"
                >
                  Total Experience <span style={{ color: "red" }}>*</span>
                </MaterialTypography>
              </MaterialBox>
              <MaterialInput
                name="totalexperience"
                // type="number"
                value={screening.totalexperience}
                customStyles={{ optionPadding: 20 }}
                onChange={handleScreenChange}
                error={
                  screening.totalexperienceStatus === "error" ? true : false
                }
                success={
                  screening.totalexperienceStatus === "success" ? true : false
                }
                disabled={togglePage.view === true ? true : false}
                //   isClearable
              />
              {screening.totalexperienceStatus === "error" && (
                <FormControl error>
                <FormHelperText>
                  Please enter a valid total experience (up to 2 digits and 2 decimal places).
                </FormHelperText>
              </FormControl>
              
              )}
            </Grid>
            <Grid size={{ xs: 5, sm: 4 }}>
              <MaterialBox lineHeight={0} display="inline-block">
                <MaterialTypography
                  component="label"
                  variant="caption"
                  fontWeight="bold"
                >
                  Relevant Experience <span style={{ color: "red" }}>*</span>
                </MaterialTypography>
              </MaterialBox>
              <MaterialInput
                name="relevantexperience"
                // type="number"
                value={screening.relevantexperience}
                customStyles={{ optionPadding: 20 }}
                onChange={handleScreenChange}
                error={
                  screening.relevantexperienceStatus === "error" ? true : false
                }
                success={
                  screening.relevantexperienceStatus === "success"
                    ? true
                    : false
                }
                disabled={togglePage.view === true ? true : false}
                //   isClearable
              />
              {screening.relevantexperienceStatus === "error" && (
                <FormControl error>
                  <FormHelperText>
                    Please enter a valid  Relevant experience (up to 2 digits and 2 decimal places)
                  </FormHelperText>
                </FormControl>
              )}
            </Grid>
            <Grid size={{ xs: 5, sm: 4 }}>
              <MaterialBox lineHeight={0} display="inline-block">
                <MaterialTypography
                  component="label"
                  variant="caption"
                  fontWeight="bold"
                >
                  Current CTC <span style={{ color: "red" }}>*</span>
                </MaterialTypography>
              </MaterialBox>
              <MaterialInput
                name="currentctc"
              
                value={screening.currentctc}
                customStyles={{ optionPadding: 20 }}
                onChange={handlepostiondetails222}
                error={screening.currentctcStatus === "error" ? true : false}
                success={
                  screening.currentctcStatus === "success" ? true : false
                }
                disabled={togglePage.view === true ? true : false}
                //   isClearable
              />
              {screening.currentctcStatus === "error" && (
                <FormControl error>
                  <FormHelperText>
                  Enter a valid Salary (5 to 7 digits)
                  </FormHelperText>
                </FormControl>
              )}
            </Grid>
            <Grid size={{ xs: 5, sm: 4 }}>
              <MaterialBox lineHeight={0} display="inline-block">
                <MaterialTypography
                  component="label"
                  variant="caption"
                  fontWeight="bold"
                >
                  Expected CTC <span style={{ color: "red" }}>*</span>
                </MaterialTypography>
              </MaterialBox>
              <MaterialInput
                name="expectedctc"
               
                value={screening.expectedctc}
                customStyles={{ optionPadding: 20 }}
                onChange={handlepostiondetails33}
                error={screening.expectedctcStatus === "error" ? true : false}
                success={
                  screening.expectedctcStatus === "success" ? true : false
                }
                disabled={togglePage.view === true ? true : false}
                //   isClearable
              />
              {screening.expectedctcStatus === "error" && (
                <FormControl error>
                  <FormHelperText>
                  Enter a valid Salary (5 to 7 digits)
                  </FormHelperText>
                </FormControl>
              )}
            </Grid>
            <Grid size={{ xs: 5, sm: 4 }}>
              <MaterialBox lineHeight={0} display="inline-block">
                <MaterialTypography
                  component="label"
                  variant="caption"
                  fontWeight="bold"
                >
                  Lead Time <span style={{ color: "red" }}>*</span>
                </MaterialTypography>
              </MaterialBox>
              <MaterialInput
                name="leadtime"
                value={screening.leadtime}
                customStyles={{ optionPadding: 20 }}
                onChange={handleScreenChange}
                error={screening.leadtimeStatus === "error" ? true : false}
                success={screening.leadtimeStatus === "success" ? true : false}
                disabled={togglePage.view === true ? true : false}
                //   isClearable
              />
              {screening.leadtimeStatus === "error" && (
                <FormControl error>
                  <FormHelperText>
                    Please enter a valid number for Lead Time
                  </FormHelperText>
                </FormControl>
              )}
            </Grid>
            <Grid size={{ xs: 5, sm: 4 }}>
              <MaterialBox lineHeight={0} display="inline-block">
                <MaterialTypography
                  component="label"
                  variant="caption"
                  fontWeight="bold"
                >
                  Year of Passing <span style={{ color: "red" }}>*</span>
                </MaterialTypography>
              </MaterialBox>
              <MaterialInput
                name="yearpassing"
                
                value={screening.yearpassing}
                customStyles={{ optionPadding: 20 }}
                onChange={handleScreenChange}
                error={screening.yearpassingStatus === "error" ? true : false}
                success={
                  screening.yearpassingStatus === "success" ? true : false
                }
                disabled={togglePage.view === true ? true : false}
                //   isClearable
              />
              {screening.yearpassingStatus === "error" && (
                <FormControl error>
                  <FormHelperText>
                    Please enter a valid year of passing.
                  </FormHelperText>
                </FormControl>
              )}
            </Grid>
            <Grid size={{ xs: 5, sm: 4 }}>
              <MaterialBox lineHeight={0} display="inline-block">
                <MaterialTypography
                  component="label"
                  variant="caption"
                  fontWeight="bold"
                >
                  Current Employer <span style={{ color: "red" }}>*</span>
                </MaterialTypography>
              </MaterialBox>
              <MaterialInput
                name="currentemployer"
                value={screening.currentemployer}
                customStyles={{ optionPadding: 20 }}
                onChange={handleScreenChange}
                error={
                  screening.currentemployerStatus === "error" ? true : false
                }
                success={
                  screening.currentemployerStatus === "success" ? true : false
                }
                disabled={togglePage.view === true ? true : false}
                //   isClearable
              />
              {screening.currentemployerStatus === "error" && (
                <FormControl error>
                  <FormHelperText>
                    Current Employer should be a maximum of 75 characters long
                    and can contain only alphabets.
                  </FormHelperText>
                </FormControl>
              )}
            </Grid>
            <Grid size={{ xs: 5, sm: 4 }}>
              <MaterialBox lineHeight={0} display="inline-block">
                <MaterialTypography
                  component="label"
                  variant="caption"
                  fontWeight="bold"
                >
                  Location 
                </MaterialTypography>
              </MaterialBox>
              <MaterialInput
                name="location"
                multiline
                rows={3.5}
                value={screening.location}
                customStyles={{ optionPadding: 20 }}
                onChange={handleScreenChange}
                error={screening.locationStatus === "error" ? true : false}
                success={screening.locationStatus === "success" ? true : false}
                disabled={togglePage.view === true ? true : false}
                //   isClearable
              />
              {screening.locationStatus === "error" && (
                <FormControl error>
                  <FormHelperText>
                    Location should be a maximum of 25 characters long and can
                    contain only alphabets.
                  </FormHelperText>
                </FormControl>
              )}
            </Grid>
        
            <Grid size={{ xs: 5, sm: 4 }}>
              <MaterialBox lineHeight={0} display="inline-block">
                <MaterialTypography
                  component="label"
                  variant="caption"
                  fontWeight="bold"
                >
                  Interview Availability
                </MaterialTypography>
              </MaterialBox>
              <MaterialInput
    name="interviewavailability"
    type="datetime-local"
    value={screening.interviewavailability}
    customStyles={{ optionPadding: 20 }}
    onChange={handleScreenChange}
    error={screening.interviewavailabilityStatus === "error"}
    success={screening.interviewavailabilityStatus === "success"}
    disabled={togglePage.view === true ? true : false}
    inputProps={{
      min: new Date().toISOString().slice(0, 16), // Restricts to current date & future
    }}
  />
              {screening.interviewavailabilityStatus === "error" && (
                <FormControl error>
                  <FormHelperText>
                    Please select a valid date and time.
                  </FormHelperText>
                </FormControl>
              )}
            </Grid>
            <Grid size={{ xs: 5, sm: 4 }}>
              <MaterialBox lineHeight={0} display="inline-block">
                <MaterialTypography
                  component="label"
                  variant="caption"
                  fontWeight="bold"
                >
                  Interviewer
                </MaterialTypography>
              </MaterialBox>
              <MaterialInput
                name="interviewer"
                value={screening.interviewer}
                customStyles={{ optionPadding: 20 }}
                onChange={handleScreenChange} //selectedValue, event
               
                error={screening.interviewerStatus === "error" ? true : false}
                success={
                  screening.interviewerStatus === "success" ? true : false
                }
                disabled={togglePage.view === true ? true : false}
                //   isClearable
              />
              {screening.interviewerStatus === "error" && (
                <FormControl error>
                  <FormHelperText> Interviewer should be contain only alphabets.</FormHelperText>
                </FormControl>
              )}
            </Grid>
            <Grid size={{ xs: 5, sm: 5 }}>
              <MaterialBox lineHeight={0} display="inline-block">
                <MaterialTypography
                  component="label"
                  variant="caption"
                  fontWeight="bold"
                >
                  Comments
                </MaterialTypography>
              </MaterialBox>
              <MaterialInput
                name="comments"
                multiline
                rows={3.5}
                value={screening.comments}
                customStyles={{ optionPadding: 20 }}
                onChange={handleScreenChange}
                error={screening.commentsStatus === "error" ? true : false}
                success={screening.commentsStatus === "success" ? true : false}
                disabled={togglePage.view === true ? true : false}
                //   isClearable
              />
              {screening.commentsStatus === "error" && (
                <FormControl error>
                  <FormHelperText>
                    Comments should be a maximum of 100 characters long and can
                    contain only alphabets.
                  </FormHelperText>
                </FormControl>
              )}
            </Grid>
            <Grid size={{ xs: 5, sm: 4 }}>
              <MaterialBox lineHeight={0} display="inline-block">
                <MaterialTypography
                  component="label"
                  variant="caption"
                  fontWeight="bold"
                >
                  Status <span style={{ color: "red" }}>*</span>
                </MaterialTypography>
              </MaterialBox>
              <MaterialSelect
                name="screeningStatus"
                value={screening.screeningStatus}
                customStyles={{ optionPadding: 20 }}
                onChange={handleScreenChange} //selectedValue, event
                options={ScreenStatus.map((value) => {
                  return {
                    value: value.value,
                    label: value.label,
                  };
                })}
                error={screening.screeningStatusStatus === "error" ? true : false}
                success={screening.screeningStatusStatus === "success" ? true : false}
                isDisabled={togglePage.view === true ? true : false}
                //   isClearable
              />
              {screening.screeningStatusStatus === "error" && (
                <FormControl error>
                  <FormHelperText>Status is Mandatory</FormHelperText>
                </FormControl>
              )}
            </Grid>
          </Grid>
        </CardContent>
        {/* <MaterialBox
          display="flex"
          justifyContent="flex-end"
          alignItems="center"
        >
          <MaterialButton
            sx={{ m: 2 }}
            variant="gradient"
            color="dark"
             disabled={!checkAllFields()}
            onClick={handleAddSource}
          >
            Submit
          </MaterialButton>
        </MaterialBox> */}
            <MaterialBox
                     display="flex"
                     justifyContent="flex-end"
                     alignItems="center"
                   >
                     {/* Left side: Close button (Only visible when editing or viewing) */}
                     {(togglePage.edit === true || togglePage.view === true) && (
                       <MaterialButton
                         variant="gradient"
                         color="dark"
                         sx={{ m: 2 }}
                         onClick={handlecancel} 
                       >
                         Close
                       </MaterialButton>
                     )}
         
                     {/* Right side: Buttons */}
                     <MaterialBox
                       display="flex"
                       justifyContent="flex-end"
                       alignItems="center"
                       flexGrow={1}
                     >
                       {togglePage.edit === true ? (
                         <>
                           {/* <MaterialButton
                             variant="gradient"
                             color="dark"
                             disabled={pageState.state === "submitting"}
                            //  onClick={handleDiscard}
                           >
                             Discard
                           </MaterialButton> */}
                           <MaterialButton
                             sx={{ m: 2 }}
                             variant="gradient"
                             color="dark"
                             disabled={pageState.state === "submitting"}
                             onClick={handleEdit}
                           >
                             Update
                           </MaterialButton>
                         </>
                       ) : togglePage.view === false && togglePage.edit === false ? (
                         <>
                           <MaterialButton
                             sx={{ m: 2 }}
                             variant="gradient"
                             color="dark"
                             onClick={handlecancel}
                           >
                             Cancel
                           </MaterialButton>
                           <MaterialButton
                             variant="gradient"
                             color="dark"
                             sx={{ m: 2 ,marginLeft : "2px"}}
                             disabled={!checkAllFields()}
                             onClick={handleAddSource}
                           >
                             Submit
                           </MaterialButton>
                         </>
                       ) : null}
                     </MaterialBox>
                   </MaterialBox>
      </Card>
    </DashboardLayout>
  );
};

export default Screening;
